import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent implements OnInit {

    @Input() title: any;

    @Output() clickClose = new EventEmitter();
    @Output() clickDismiss = new EventEmitter();

    constructor(
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit() {

    }

    btnClose() {
        this.clickClose.emit('save');
        this.activeModal.close();
    }

    btnDismiss() {
        this.clickDismiss.emit('dismiss');
        this.activeModal.dismiss();
    }
}
